function ArrowRight({color, size = 22}: {color?: string; size?: number}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.76386 3.63886C7.49538 3.90735 7.49538 4.34265 7.76386 4.61114L14.1527 11L7.76386 17.3889C7.49538 17.6574 7.49538 18.0927 7.76386 18.3611C8.03235 18.6296 8.46765 18.6296 8.73614 18.3611L15.6111 11.4861C15.8796 11.2177 15.8796 10.7823 15.6111 10.5139L8.73614 3.63886C8.46765 3.37038 8.03235 3.37038 7.76386 3.63886Z"
        fill={color || '#666666'}
      />
    </svg>
  );
}

export default ArrowRight;
